<template>
  <div>
    <Ways/>
    <Symptoms/>
    <Prevention/>
     <Who/>
    <Contacts/>
  </div>
</template>

<script>
import Ways from '@/components/Infographics/Ways.vue'
import Symptoms from '@/components/Infographics/Symptoms.vue'
import Prevention from '@/components/Infographics/Prevention.vue'
import Who from '@/components/Infographics/Who.vue'
import Contacts from '@/components/Infographics/Contacts.vue'

export default {
  components: {
    Ways,
    Symptoms,
    Prevention,
    Who,
    Contacts
  }
}
</script>